'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Option;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Option(_ref) {
    var value = _ref.value,
        children = _ref.children;

    return _react2.default.createElement(
        'option',
        { value: value },
        children
    );
}

Option.propTypes = {
    value: _propTypes2.default.any.isRequired,
    children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node])
};

Option.defaultProps = {
    children: 'Option'
};


//////////////////
// WEBPACK FOOTER
// ./~/react-conversation-form/dist/Option.js
// module id = 276
// module chunks = 0